<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Фото документа, <br> удостоверяющего личность</h1>

                <div class="form-wrap__row form-wrap__row--first">
                    <div class="file-input">
                        <div class="file-input__image-wrap">
                            <img :src="frontPreview" alt="" v-bind:class="documentInputClass" class="file-input__image">
                        </div>
                        <div class="file-input__interface-wrap">
                            <label class="file-input__label" v-html="faceLabel"></label>
                            <div class="file-input__buttons" v-if="frontFile !== ''">
                                <button class="file-input__control-link file-input__control-link--refresh" v-on:click="callFront">Заменить</button>
                                <button class="file-input__control-link file-input__control-link--clear" v-on:click="clearImage('front')">Очистить</button>
                            </div>
                            <div class="file-input__add-button-wrap" v-else>
                                <c-tooltip-button :position="'left-bottom'" :top="15" :text="'Добавить фото'" :clickEvent="callFront"></c-tooltip-button>
                            </div>
                            <input type="file" ref="frontInput" class="file-input__input" accept="image/x-png,image/gif,image/jpeg" @change="onFileChange($event, 'front')" >
                        </div>
                    </div>
                </div>

                <div class="form-wrap__visual" v-if="documentType === 'IDENTITY_CARD'">
                    <div class="form-wrap__visual-arrow"></div>
                </div>
                <div class="form-wrap__row" v-if="documentType === 'IDENTITY_CARD'">
                    <div class="file-input">
                        <div class="file-input__image-wrap">
                            <img :src="backPreview" alt=""  class="file-input__image file-input__image--back">
                        </div>
                        <div class="file-input__interface-wrap">
                            <label class="file-input__label" v-html="backLabel">Прикрепите документ с обратной стороны</label>
                            <div class="file-input__buttons" v-if="backFile !== ''">
                                <button class="file-input__control-link file-input__control-link--refresh" v-on:click="callBack">Заменить</button>
                                <button class="file-input__control-link file-input__control-link--clear" v-on:click="clearImage('back')">Очистить</button>
                            </div>
                            <div class="file-input__add-button-wrap" v-else>
                                <c-tooltip-button :position="'left-bottom'" :top="15" :text="'Добавить фото'" :clickEvent="callBack"></c-tooltip-button>
                            </div>
                            <input type="file" ref="backInput" accept="image/x-png,image/gif,image/jpeg" class="file-input__input" @change="onFileChange($event, 'back')" >
                        </div>
                    </div>
                </div>

                <div class="form-wrap__row" v-if="showButton">
                    <div class="form-button__wrap">
                        <button class="form-button form-button--yellow" v-on:click="sendDocument">Отправить документ</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/storage/index'
    import {TOGGLE_LOADER} from "@/storage/mutations";
    import Raven from 'raven-js'

    export default {
        name: 'confirmation',

        metaInfo: {
          title: 'Регистрация'
        },
        data(){
            return {
                frontFile: '',
                frontPreview: '',

                backFile: '',
                backPreview: ''
            }
        },
        methods: {
            callFront: function(){
                this.$refs.frontInput.click();
            },
            callBack: function(){
               this.$refs.backInput.click();
            },
            clearImage: function(img){
                this[img+'File'] = '';
                this[img+'Preview'] = '';
                // clear file input
                this.$refs[img+'Input'].type = 'text';
                this.$refs[img+'Input'].type = 'file';

            },
            onFileChange: function (event, img) {
                this[img+'File'] = event.target.files[0];
                this[img+'Preview'] = (window.URL || window.webkitURL).createObjectURL(this[img+'File']);
            },

            sendDocument: function () {
                let _this = this;
                let data = new FormData();
                data.append('filename-front', 'front_photo.' + this.getExtension(this.frontFile.name));
                data.append('photo-front', this.frontFile);
                if(this.documentType === 'IDENTITY_CARD'){
                    data.append('filename-back',  'back_photo.' + this.getExtension(this.backFile.name));
                    data.append('photo-back', this.backFile);
                }
                data.append('creditId', this.$store.state.credit.creditID);

                this.$store.commit(TOGGLE_LOADER, {state: true});
                this.$http.post('/json/identification/photo', data).then(
                  response => {
                      if( response.status ){
                          Raven.captureMessage('Step end: '+_this.$options.name, {
                              level: 'info'
                          });
                          _this.$router.push({name: 'Conditions'});
                          _this.$store.commit(TOGGLE_LOADER, {state: false});
                      }
                  },
                  response => {

                  }
                );
            },
            getExtension: function ( fileName) {
                return fileName.split('.').pop();
            }
        },
        computed: {
            documentInputClass: function(){
              return {
                  'file-input__image--face' : this.documentType === 'IDENTITY_CARD',
                  'file-input__image--passport' : this.documentType === 'PASSPORT'
              }
            },
            faceLabel: function(){
                return this.frontFile === '' ? 'Прикрепите лицевую </br> сторону документа': 'Лицевая сторона';
            },
            backLabel: function(){
                return this.backFile === '' ? 'Прикрепите документ </br> с обратной стороны': 'Обратная сторона';
            },


            documentType: function () {
                return this.$store.state.profile.document;
            },
            showButton: function () {
                if( this.documentType === 'IDENTITY_CARD'){
                    return this.frontFile !== '' && this.backFile !== '';
                }else{
                    return this.frontFile !== '';
                }
            }
        },
        beforeCreate(){
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
        },
        mounted(){
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 85, nextPercent: 5});
            this.$store.dispatch('credit/GET_CREDIT_INFO');
        }
    }
</script>

<style lang="scss">

</style>